import { roles } from '@/config/roles'

const routes = [
  {
    name: 'ContentEvents',
    path: '/content/events',
    component: () => import('@/views/content/events/index'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentEvent',
    path: '/content/events/:id',
    component: () => import('@/views/content/events/Event'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentNews',
    path: '/content/news',
    component: () => import('@/views/content/news/index'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentSingleNews',
    path: '/content/news/:id',
    component: () => import('@/views/content/news/SingleNews'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentCourses',
    path: '/content/courses',
    component: () => import('@/views/content/courses/index'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentTrainings',
    path: '/content/training',
    component: () => import('@/views/content/training/index.vue'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentTrainingContent',
    path: '/content/training/:trainingId',
    component: () => import('@/views/content/training/Content.vue'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentTrainingPanel',
    path: '/content/training/:trainingId/panels/:panelId',
    component: () => import('@/views/content/training/Panel.vue'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentTrainingStage',
    path: '/content/training/:trainingId/stages/:stageIndex',
    component: () => import('@/views/content/training/Stage.vue'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentTrainingCode',
    path: '/content/training/:trainingId/code',
    component: () => import('@/views/content/training/Code.vue'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentCourse',
    path: '/content/courses/:courseBookId',
    component: () => import('@/views/content/courses/Course'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentCourseSubSection',
    path: '/content/courses/:courseBookId/section/:sectionId/subsection/:subsectionId',
    component: () => import('@/views/content/courses/SubSection'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentCourseTest',
    path: '/content/courses/:courseBookId/test/:sectionId',
    component: () => import('@/views/content/courses/Test'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentPartners',
    path: '/content/partners',
    component: () => import('@/views/content/partners/index'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentPartner',
    path: '/content/partners/:id',
    component: () => import('@/views/content/partners/Partner'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentClasses',
    path: '/content/classes',
    component: () => import('@/views/content/classes/index'),
    meta: {
      roles: [roles.content]
    }
  },
  {
    name: 'ContentClass',
    path: '/content/classes/:id',
    component: () => import('@/views/content/classes/Class'),
    meta: {
      roles: [roles.content]
    }
  }
]
export default routes
